module.exports = __webpack_public_path__ + "img/g2.80cc5f91.png";